import { ImFacebook, ImLinkedin } from "react-icons/im";
import { RiInstagramFill } from "react-icons/ri";
import "./Footer.css";

const external = { target: "_blank", rel: "noreferrer" };

export default function Footer() {
  return (
    <footer>
      <a href="#top" className="footer__logo">
        Back to top
      </a>

      <ul className="permalinks">
        <li>
          <a href="#top">Home</a>
        </li>
        <li>
          <a href="#work">Work</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#career">Career</a>
        </li>
        <li>
          <a href="#skills">Skills</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <div className="footer__socials">
        <a href="https://m.me/trai.torti/" {...external}>
          <ImFacebook />
        </a>
        <a href="https://www.instagram.com/traiflip/" {...external}>
          <RiInstagramFill />
        </a>
        <a
          href="https://www.linkedin.com/in/trai-torti-7980341a2/"
          {...external}
        >
          <ImLinkedin />
        </a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Trai Torti. All rights reserved.</small>
      </div>
    </footer>
  );
}
